<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-btn-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Tabs</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <h2>Customized Tools for Tab</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="toppadding" class="c-input-check-inline__input" type="checkbox" name="" [(ngModel)]="padding">
        <label for="toppadding" class="c-input-check-inline__label">Extra Padding</label>
      </div>
    </div>
  </div>
  <maced-tab [tabItems]="tabItems" id="TabsContainer1" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
    [padding]="padding">
    <maced-tabcontent [active]="tab.isActive" [data]="tab" tabindex="0" [ariaLabelledby]="tab.id + tabIndex" *ngFor="let tab of tabItems; let tabIndex=index;">
      <p>{{tab.tabContentData}}</p>
    </maced-tabcontent>
  </maced-tab>

  <h3> Example for Less Number Of Tabs</h3>

  <maced-tab [tabItems]="tabItemsForTab" id="TabsContainer2" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
    [padding]="padding" [queryParams]="queryParams">
    <maced-tabcontent [active]="tab.isActive" [data]="tab" [ariaLabelledby]="tab.id + tabIndex" *ngFor="let tab of tabItemsForTab; let tabIndex=index;">
      <p>{{tab.tabContentData}}</p>
    </maced-tabcontent>
  </maced-tab>

  <h3>Tab with gray background</h3>
  <maced-tab [tabItems]="tabItemsGray" id="TabsContainer3" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
    [padding]="padding" color="gray">
    <maced-tabcontent [active]="tab.isActive" [data]="tab" [ariaLabelledby]="tab.id + tabIndex" *ngFor="let tab of tabItemsGray; let tabIndex=index;">
      <p>{{tab.tabContentData}}</p>
    </maced-tabcontent>
  </maced-tab>

  <h3>Tab with white background</h3>
  <maced-tab [tabItems]="tabItemsForTabGray" id="TabsContainer4" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
    [padding]="padding" color="white">
    <maced-tabcontent [active]="tab.isActive" [data]="tab" [ariaLabelledby]="tab.id + tabIndex" *ngFor="let tab of tabItemsForTabGray; let tabIndex=index;">
      <p>{{tab.tabContentData}}</p>
    </maced-tabcontent>
  </maced-tab>

  <h3>Tab with Swipe</h3>
  <maced-tab [tabItems]="tabItemsForSwipe" id="TabsContainer5" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
    [padding]="padding" color="white" [hasSwipe]="true">
    <maced-tabcontent [active]="tab.isActive" [data]="tab" [ariaLabelledby]="tab.id + tabIndex" *ngFor="let tab of tabItemsForSwipe; let tabIndex=index;">
      <p>{{tab.tabContentData}}</p>
    </maced-tabcontent>
  </maced-tab>
  
  <h3>Simplified Tab with Swipe</h3> 
  <maced-tab [tabItems]="simplifiedTabItems" id="TabsContainer6" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
  [padding]="padding" color="white" [hasSwipe]="true" [hasTabEqualPadding]="true">
  <maced-tabcontent [active]="tab.isActive" [data]="tab" [ariaLabelledby]="tab.id + tabIndex" *ngFor="let tab of simplifiedTabItems; let tabIndex=index;">
      <p>{{tab.tabContentData}}</p>
  </maced-tabcontent>
</maced-tab>

<h3>Simplified Tab without Swipe</h3> 
<maced-tab [tabItems]="simplifiedTabItemsWithoutSwipe" id="TabsContainer7" [currentTab]="activeTab" [ariaLabels]="ariaLabels"
[padding]="padding" color="white" [hasTabEqualPadding]="true">
<maced-tabcontent [active]="tab.isActive" [data]="tab" [ariaLabelledby]="tab.id + tabIndex" *ngFor="let tab of simplifiedTabItemsWithoutSwipe; let tabIndex=index;">
    <p>{{tab.tabContentData}}</p>
</maced-tabcontent>
</maced-tab>

<h3>Hierarchical drill-down tabs with click events</h3>
<maced-tab [tabItems]="hierarchyTabItems" id="TabsContainer8" [currentTab]="activeHierarchyTab"
  [ariaLabels]="ariaLabels" [hasClickEvent]="true" (tabClickEvent)="onHierarchyTabClick($event)">
  <maced-tabcontent [active]="tab.isActive" [data]="tab" [ariaLabelledby]="tab.id + tabIndex"
    *ngFor="let tab of hierarchyTabItems; let tabIndex=index;">
    <p>{{tab.tabContentData}}</p>
    <maced-button *ngIf="tab.isActive && tabIndex < hierarchyTabLevels.length - 1" type="button" color="primary"
      label="Open child level" (click)="openHierarchyChild(tabIndex)"></maced-button>
  </maced-tabcontent>
</maced-tab>
</div>
